import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { Alert, AlertTitle, Slide, Snackbar } from '@mui/material';
import { preventDefault } from 'console/shared/hooks/utils';
import { useAction } from 'shared/hooks/redux/hooks';
import { markDeclined } from 'entities/device.service.accessories.upgrade/model/reducer';
import { useUpgradeExtensionsDialog } from 'features/device.settings.upgrade-extensions/ui/dialog';
export const UpgradeAccessoriesSuggestion = memo(function UpgradeAccessoriesSuggestionImpl(props) {
    const { suggestion } = props;
    const { device, version, accessor } = suggestion;
    const onMarkDeclined = useAction(markDeclined);
    const onDecline = useCallback((e) => {
        preventDefault(e);
        onMarkDeclined({
            device_id: device.device_id,
            id: version.original,
            io_ext_id: accessor.id,
        });
    }, [device.device_id, version.original, accessor.id]);
    const [UpgradeExtensionsDialog, open] = useUpgradeExtensionsDialog();
    return (_jsxs(_Fragment, { children: [_jsx(Snackbar, { anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, open: true, TransitionComponent: Slide, sx: {
                    position: 'static',
                }, children: _jsxs(Alert, { onClick: open, severity: "info", variant: "filled", sx: { alignItems: 'center', maxWidth: '425px' }, 
                    //@ts-ignore
                    onClose: onDecline, children: [_jsxs(AlertTitle, { children: ["\u00AB", device.name, ".", accessor.name, "\u00BB \u0435\u0441\u0442\u044C \u043D\u043E\u0432\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F \u041F\u041E\u00A0\u2014\u00A0", version.last, ". \u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u0430\u044F\u00A0\u2014\u00A0", version.current] }), "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F"] }) }), _jsx(UpgradeExtensionsDialog, { device_id: device.device_id, serial: accessor.serial, hw_type: accessor.hw, name: accessor.name })] }));
});
